import { searchModels, createModel, updateModel, deleteModel, restoreModel, getModel, getRevisions, duplicateModel, replaceTags } from '../../../../redux/DefaultModelActions';

const model = 'Album';
const route = '/v1/album';

export const searchAlbum = (page, limit, search, view, args) => searchModels(model, route, page, limit, search, view, args);
export const createAlbum = (args) => createModel(model, route, args);
export const updateAlbum = (id, args) => updateModel(model, route, id, args);
export const deleteAlbum = (id) => deleteModel(model, route, id);
export const restoreAlbum = (id) => restoreModel(model, route, id);
export const getAlbum = (id) => getModel(model, route, id);
export const getAlbumRevision = (id) => getRevisions(model, route, id);
export const duplicateAlbum = (id) => duplicateModel(model, route, id);

// Tagging
export const replaceAlbumTags = (terms, contentType, contentId, args) => replaceTags(model, route, terms, contentType, contentId, args);